<div class="mb-2 pb-0" [ngClass]="color">
  <h3 class="mx-2 pt-3">{{ title }}</h3>
  <div class="mx-2 w-90 bg-primary" style="height: 2px"></div>
</div>
